import { useState, useCallback, useEffect } from 'react'

import { VanCreativeModel, VanPlacementConfigModel } from '@marketplace-web/ads/ads-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import { getVanCreative } from '../../components/Advertisement/VanAdvertisement/utils'
import useVanAdLoadtimeLogging from '../useVanAdLoadtimeLogging'

type Props = {
  config: VanPlacementConfigModel
  creative: VanCreativeModel
}

function useFetchVanCreative({ config, creative }: Props) {
  const [iframeContent, setIframeContent] = useState<string | null>(null)

  const { countryCode, shape, page, platform, placementId } = config
  const { contentLink } = creative

  const shouldForceVanAdError = useFeatureSwitch('web_van_ad_force_error')

  const { onVanAdAssetLoadTimeRequest } = useVanAdLoadtimeLogging({
    countryCode,
    shape,
    page,
    platform,
  })

  const fetchCreative = useCallback(async () => {
    const fetchStartTime = Date.now()

    const { response, text } = await getVanCreative(contentLink, shouldForceVanAdError)
    const fetchCreativeEndTime = Date.now()
    const fetchTime = fetchCreativeEndTime - fetchStartTime

    if (response.ok && response.status === 200 && text) {
      setIframeContent(text)
    }

    onVanAdAssetLoadTimeRequest(placementId, fetchTime)
  }, [shouldForceVanAdError, contentLink, placementId, onVanAdAssetLoadTimeRequest])

  useEffect(() => {
    fetchCreative()
  }, [fetchCreative])

  return { iframeContent }
}

export default useFetchVanCreative
